function startFlashSaleTimer() {
    const saleBox = document.getElementById("flash-sale");
    const timerEl = document.getElementById("sale-timer");
  
    const saleStart = new Date("2026-06-11T18:30:00Z");
    const saleEnd = new Date("2026-06-13T18:30:00Z");
  
    function updateTimer() {
      const now = new Date();
  
      if (now < saleStart) {
        saleBox.style.display = "none";
        return;
      }
  
      if (now >= saleEnd) {
        saleBox.style.display = "block";
        timerEl.textContent = "SALE ENDED";
        return;
      }
  
      saleBox.style.display = "block";
  
      const diff = saleEnd - now;
  
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  
      timerEl.textContent =
        `${String(hours).padStart(2, "0")}:` +
        `${String(minutes).padStart(2, "0")}:` +
        `${String(seconds).padStart(2, "0")}`;
    }
  
    updateTimer();
    setInterval(updateTimer, 1000);
  }
  
  document.addEventListener("DOMContentLoaded", startFlashSaleTimer);